import React from "react";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeam from "../../hooks/queryResults/useTeam";
import Box from "../layout/Box";
import Loading from "../ui/Loading";
import TeamBanner from "./TeamBanner";
import TeamGamesTable from "./TeamGamesTable";

const TeamGamesModule = () => {
  const { team, teams } = useTeam();

  const isLoading = useIsLoading(teams, team);

  return (
    <Box
      title={"games"}
      id={"team-games"}
      boxWidth={"60%"}
      style={{ margin: "1rem" }}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <TeamBanner team={team} />
          <TeamGamesTable />
        </>
      )}
    </Box>
  );
};

export default TeamGamesModule;
